import { convertEnum } from "../enumUtil";
/**
 * 性别
 */
export const ESex = {
  /** 未开通 */
  NotOpened: 1,

  /** 已开通 */
  Opened: 2,

  /** 已过期 */
  Expired: 3,
};
// console.log(eSex,'ESexESexESexESex');
export const [MSex, OSex] = convertEnum([
  [ESex.NotOpened, "未开通"],
  [ESex.Opened, "已开通"],
  [ESex.Expired, "已过期"],
]);

/**
 * 断路器在线状态
 */
export const EPresence = {
  /** 在线 */
  onLine: 1,

  /** 离线 */
  offline: 2,
};
// console.log(eSex,'ESexESexESexESex');
export const [MPresence, OPresence] = convertEnum([
  [EPresence.onLine, "在线"],
  [EPresence.offline, "离线"],
]);

/**
 * 运行状态
 */
export const ERunningState = {
  /** 正常 */
  normal: 1,

  /** 故障 */
  fault: 2,

  /** 告警 */
  giveAnAlarm: 3,

  /** 变位 */
  Displacement: 4,
};
// console.log(eSex,'ESexESexESexESex');
export const [MERunningState, OERunningState] = convertEnum([
  [ERunningState.normal, "正常"],
  [ERunningState.fault, "故障"],
  [ERunningState.giveAnAlarm, "告警"],
  [ERunningState.Displacement, "变位"],
]);

/**
 * 闸状态
 */
export const EGateState = {
  /** 分闸 */
  opening: 1,

  /** 合闸 */
  Closing: 2,
};
// console.log(eSex,'ESexESexESexESex');
export const [MGateState, OGateState] = convertEnum([
  [EGateState.opening, "分闸"],
  [EGateState.Closing, "合闸"],
]);

/**
 * 电能质量 -- 类型
 */
export const EQuality = {
  /** 全部 */
  whole: 1,

  /** 过压报警计数 */
  overvoltage: 2,

  /** 欠压报警计数 */
  undervoltage: 3,

  /** 电压不平衡报警计数 */
  imbalance: 4,
  /** 短时电压中断报警计数 */
  interrupt: 5,
  /** 短时电压下降报警计数 */
  decline: 6,
  /** 短时电压上升报警计数 */
  rise: 7,
  /** 缓慢电压暂降1级报警计数 */
  DropToOne: 8,
  /** 缓慢电压暂降2级报警计数 */
  DropToTwo: 9,
  /** 缓慢电压暂降3级报警计数 */
  DropToThree: 10,
  /** 缓慢电压暂升1级报警计数 */
  AscendToOne: 11,
  /** 缓慢电压暂升2级报警计数 */
  AscendToTwo: 12,
};
export const [MQuality, OQuality] = convertEnum([
  [EQuality.whole, "全部"],
  [EQuality.overvoltage, "过压报警计数"],
  [EQuality.undervoltage, "欠压报警计数"],
  [EQuality.imbalance, "电压不平衡报警计数"],
  [EQuality.interrupt, "短时电压中断报警计数"],
  [EQuality.decline, "短时电压下降报警计数"],
  [EQuality.rise, "短时电压上升报警计数"],
  [EQuality.DropToOne, "缓慢电压暂降1级报警计数"],
  [EQuality.DropToTwo, "缓慢电压暂降2级报警计数"],
  [EQuality.DropToThree, "缓慢电压暂降3级报警计数"],
  [EQuality.AscendToOne, "缓慢电压暂升1级报警计数"],
  [EQuality.AscendToTwo, "缓慢电压暂升2级报警计数"],
]);

/**
 * 审核状态
 */
export const EExamine = {
  /** 待审核 */
  Audit: 1,

  /** 审核通过 */
  Approved: 2,

  /** 审核拒绝 */
  ReviewReject: 3,
};
export const [MExamine, OExamine] = convertEnum([
  [EExamine.Audit, "待审核"],
  [EExamine.Approved, "审核通过"],
  [EExamine.ReviewReject, "审核拒绝"],
]);

/**
 * 合闸策略
 */
export const EClosing = {
  /** 允许 */
  allow: 1,

  /** 禁止 */
  prohibit: 2,
};
export const [MClosing, OClosing] = convertEnum([
  [EClosing.allow, "允许"],
  [EClosing.prohibit, "禁止"],
]);

/**
 * 升级方式
 */
export const EUpgradeMethod = {
  /** 提醒升级 */
  remind: 1,

  /** 静默升级 */
  becomeSilent: 2,
};
export const [MUpgradeMethod, OUpgradeMethod] = convertEnum([
  [EUpgradeMethod.remind, "提醒升级"],
  [EUpgradeMethod.becomeSilent, "静默升级"],
]);

/**
 * 升级范围
 */
export const EUpgradeScope = {
  /** 指定型号 */
  model: 1,

  /** 指定设备 */
  device: 2,

  /** 指定网关 */
  gateway: 3,
};
export const [MUpgradeScope, OUpgradeScope] = convertEnum([
  [EUpgradeScope.model, "指定型号"],
  [EUpgradeScope.device, "指定设备"],
  [EUpgradeScope.gateway, "指定网关"],
]);

/**
 * 产品系列
 */
export const EProductSeries = {
  /** NDB5E */
  NDB5E: "NDB5E",

  /** NSCCB */
  NSCCB: "NSCCB",

  /** DFLRD */
  DFLRD: "DFLRD",

  /** DFNDM */
  DFNDM: "DFNDM",

  /** link系列网关 */
  DFTMB: "DFTMB",

  /** link系列断路器 */
  LNB63: "LNB63",

  /** link系列断路器 */
  DFELG: "DFELG",

  /** tag网关 */
  DFMMX: "DFMMX"
};
export const [MProductSeries, OProductSeries] = convertEnum([
  [EProductSeries.NDB5E, "NDB5E"],
  [EProductSeries.NSCCB, "NSCCB"],
  [EProductSeries.DFLRD, "DFLRD"],
  [EProductSeries.DFNDM, "DFNDM"],
  [EProductSeries.DFTMB, "DFTMB"],
  [EProductSeries.LNB63, "LNB63"],
  [EProductSeries.DFELG, "DFELG"],
  [EProductSeries.DFMMX, "DFMMX"],
]);

/**
 * 产品类型
 */
export const EProductType = {
  /** 网关 */
  model: "0",

  /** 断路器 */
  device: "1",

  /** 网关断路器一体 */
  gatewaydevice: "2",

  /** 负载报警网关-无从机 */
  gateway: "3",

  /** 报警网关-无从机 */
  gatewayalert: "4",

  /** AI负载识别网关 */
  gatewayAiLoad: "5",

  /** 采集模块 */
  collectionModule: "6",
};
export const [MProductType, OProductType] = convertEnum([
  [EProductType.model, "网关"],
  [EProductType.device, "断路器"],
  [EProductType.gatewaydevice, "网关断路器一体"],
  [EProductType.gateway, "负载报警网关-无从机"],
  [EProductType.gatewayalert, "报警网关-无从机"],
  [EProductType.gatewayAiLoad, "AI负载识别网关"],
  [EProductType.collectionModule, "采集模块"],
]);

/** 网关子类型 */
const gatewaySubType = [
  {
    label: "NB-IOT",
    value: "00"
  },
  {
    label: "4G网关",
    value: "01"
  },
  {
    label: "ETH网关",
    value: "02"
  },
  {
    label: "WIFI网关",
    value: "03"
  },
  {
    label: "网关服务器",
    value: "04"
  },
  {
    label: "80X网关",
    value: "05"
  }
]

/**
 * 断路器子类型
 */
const breakerSubType = [
  {
    value: "30",
    label: "固态断路器",
  },
  {
    value: "06",
    label: "不带漏电断路器",
  },
  {
    value: "07",
    label: "带漏电断路器",
  },
  {
    value: "08",
    label: "直流断路器",
  },
]
/**
 * 采集器子类型
 */
const collectionSubType = [
  {
    value: "01",
    label: "蓝牙采集模块",
  },
  {
    value: "02",
    label: "WIFI采集模块",
  }
]
/**
 * 设备子类型
 */
export const EProductSubType = {
  /** 网关 */
  "0": gatewaySubType,
  "1": breakerSubType,
  "2": gatewaySubType,
  "3": gatewaySubType,
  "4": gatewaySubType,
  "5": gatewaySubType,
  "6": collectionSubType,
}

/**
 * MCU品牌
 */
export const EMcuBrand = {
  /** 兆易创新 */
  Giga: "GD",
  /** 恩智浦 */
  NXP: "NX",
  /** 乐鑫 */
  Espressif: "ES",
}
export const [MMcuBrand, OMcuBrand] = convertEnum([
  [EMcuBrand.Giga, "兆易创新"],
  [EMcuBrand.NXP, "恩智浦"],
  [EMcuBrand.Espressif, "乐鑫"],
])

/**
 * 品牌子型号
 */
export const EBrandSubModel = {
  /** 兆易创新 */
  GD: [
    {
      label: "GD32E503",
      value: "00"
    },
    {
      label: "GD32E103",
      value: "01"
    },
    {
      label: "GD32E230",
      value: "02"
    },
    {
      label: "GD32E515",
      value: "03"
    },
    {
      label: "GD32F527",
      value: "04"
    }
  ],
  /** 恩智浦 */
  NX: [
    {
      label: "MK22FX512",
      value: "00"
    },
    {
      label: "MK22FN128",
      value: "01"
    },
  ],
  /** 乐鑫 */
  ES: [
    {
      label: "ESPC61",
      value: "00"
    },
    {
      label: "ESP8684",
      value: "01"
    },
  ]
}
